<template>
  <el-dialog
    :model-value="visible"
    title="Учёт серийного ключа"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="420px"
    append-to-body
  >
    <p class="serial-key-hint">
      В ваших учётных данных не записан серийный ключ. Укажите выданный вам ключ —
      он сохраняется как информация о выдаче и больше не потребуется.
    </p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="0"
      @submit.prevent
    >
      <el-form-item prop="key">
        <el-input
          v-model="form.key"
          placeholder="Введите серийный ключ"
          :disabled="saving"
          @keyup.enter="submit"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button :disabled="saving" @click="cancel">Выйти</el-button>
        <el-button type="primary" :loading="saving" @click="submit">
          Сохранить
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ElMessage } from 'element-plus'
import api from '../api'

export default {
  name: 'SerialKeyDialog',
  data() {
    return {
      saving: false,
      form: {
        key: ''
      },
      rules: {
        key: [
          { required: true, message: 'Введите серийный ключ', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user']),
    // Окно обязательно, пока записанный ключ не появился в данных пользователя
    visible() {
      return this.isAuthenticated && !!this.user && !this.user.serial_key
    }
  },
  watch: {
    visible(value) {
      // При новом показе очищаем поле и ошибки валидации
      if (value) {
        this.form.key = ''
        this.$nextTick(() => this.$refs.form?.clearValidate())
      }
    }
  },
  methods: {
    ...mapActions(['logout']),
    async submit() {
      if (!this.$refs.form) return
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return

      this.saving = true
      try {
        const { data } = await api.setSerialKey(this.form.key.trim())
        this.$store.commit('SET_USER', data.user)
        ElMessage.success('Серийный ключ сохранён')
      } catch (error) {
        ElMessage.error(error.response?.data?.error || 'Не удалось сохранить серийный ключ')
      } finally {
        this.saving = false
      }
    },
    async cancel() {
      // Без записанного ключа сессия не продолжается — выход из системы
      await this.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.serial-key-hint {
  margin: 0 0 16px 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
}
</style>
